import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/iv-drip-rate-calculator',
  component: () => import('../../routes/IvDripRateCalculator.svelte'),
  card: {
    id: 'iv-drip-rate-calculator',
    title: 'IV Drip Rate',
    description: 'Calculate IV drip rates and medication dosages for intravenous infusions. Supports mcg/kg/min dosing with drop factor adjustments.',
    icon: 'water_drop',
    iconBgClass: 'bg-cyan-50',
    iconTextClass: 'text-cyan-600',
    href: '/iv-drip-rate-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'IV Drip Rate Calculator – Calculate IV Medication Dosages & Drip Rates',
    description:
      'Free IV drip rate calculator to determine medication drip rates in mL/hr and gtt/min. Supports mcg/kg/min dosing for pressors, inotropes, and other IV medications.',
  },
};

export default meta;
